const makeAuthorPath = (author, page) => `/blog/authors/${author}/${page}/`;
const makeTagPath = (categoryKey, page) => `/blog/c/${categoryKey}/${page}/`;
const makeHelpSectionPath = (sectionSlug) => `/help/collections/${sectionSlug}`;
const makeHelpArticlePath = (articleSlug) => `/help/articles/${articleSlug}`;

module.exports = {
  makeAuthorPath,
  makeTagPath,
  makeHelpSectionPath,
  makeHelpArticlePath,
};
